import { useEffect, useState } from 'react'
import { Fab, Fade } from '@mui/material'
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp'
import { styled } from '@mui/material/styles'

const ScrollTopAnchor = styled('div', {
  shouldForwardProp: (prop) => prop !== 'atBottom',
})<{ atBottom?: boolean }>(({ theme, atBottom }) => ({
  position: 'fixed',
  bottom: theme.spacing(3),
  right: theme.spacing(3),
  zIndex: 2000,
  transition: theme.transitions.create('transform', {
    duration: 700,
    easing: theme.transitions.easing.easeInOut,
  }),
  transform: 'translateY(0)',
  [theme.breakpoints.down('sm')]: {
    transform: atBottom ? 'translateY(-72px)' : 'translateY(0)',
  },
}))

const ScrollTopButton = styled(Fab)(({ theme }) => ({
  boxShadow: theme.shadows[4],
}))

export default function ScrollToTop() {
  const [show, setShow] = useState(false)
  const [atBottom, setAtBottom] = useState(false)

  useEffect(() => {
    const handler = () => {
      const isAtPageBottom =
        window.innerHeight + window.scrollY >=
        document.documentElement.scrollHeight - 1

      setShow(window.scrollY > 250)
      setAtBottom(isAtPageBottom)
    }

    handler()
    window.addEventListener('scroll', handler)
    return () => window.removeEventListener('scroll', handler)
  }, [])

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }

  return (
    <ScrollTopAnchor atBottom={atBottom}>
      <Fade in={show} timeout={600}>
        <ScrollTopButton color='primary' size='medium' onClick={scrollToTop}>
          <KeyboardArrowUpIcon />
        </ScrollTopButton>
      </Fade>
    </ScrollTopAnchor>
  )
}
